"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var fromPairs_1 = __importDefault(require("lodash/fromPairs"));

var lunr_1 = __importDefault(require("lunr"));

var prop_types_1 = __importDefault(require("prop-types"));

var Hint_1 = require("./Hint");

var Path_1 = require("./Path");

var shape = prop_types_1.default.shape({
  index: prop_types_1.default.instanceOf(lunr_1.default.Index).isRequired,
  paths: prop_types_1.default.objectOf(Path_1.Path.shape).isRequired
});

var defaultCombiner = function defaultCombiner(path) {
  return path.join('.');
};

var defaultEscaper = function defaultEscaper(identifier) {
  return identifier;
};

var defaultUnescaper = function defaultUnescaper(identifier) {
  return identifier;
};

var localeEquals = function localeEquals(x, y) {
  return x.localeCompare(y, undefined, {
    sensitivity: 'accent'
  }) === 0;
};

function create(paths) {
  var index = lunr_1.default(function () {
    var _this = this;

    this.ref('id');
    this.field('path');
    paths.forEach(function (path, id) {
      return _this.add({
        id: id,
        path: path
      });
    });
  });
  var pathMap = fromPairs_1.default(paths.map(function (path, id) {
    return [id, path];
  }));
  return {
    index: index,
    paths: pathMap
  };
}

function search(index, path, options) {
  var combineFn = options && options.combineFn || defaultCombiner;
  var escapeFn = options && options.escapeFn || defaultEscaper;
  var unescapeFn = options && options.unescapeFn || defaultUnescaper;
  var results = index.index.query(function (query) {
    path.forEach(function (term) {
      query.clause({
        fields: ['path'],
        presence: lunr_1.default.Query.presence.REQUIRED,
        term: unescapeFn(term).toLocaleLowerCase(),
        wildcard: lunr_1.default.Query.wildcard.TRAILING
      });
    });
  });
  var hints = results.map(function (result) {
    var refPath = index.paths[result.ref];
    var refText = combineFn(refPath.map(escapeFn));
    return Hint_1.Hint.create(refPath, refText);
  }).filter(function (hint) {
    // Remove all hints that are exact matches for the search path.
    // If the path lengths are not the same, the hint path does not match the search path.
    if (hint.path.length !== path.length) {
      return true;
    }

    for (var i = 0; i < hint.path.length; ++i) {
      var leftEntry = hint.path[i];
      var rightEntry = path[i]; // If corresponding path entries do not match, the hint path does not match the search path.

      if (!localeEquals(leftEntry, rightEntry)) {
        return true;
      }
    } // The hint path matches the search path.


    return false;
  });
  return hints;
}

exports.CompletionIndex = {
  create: create,
  search: search,
  shape: shape
};